import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultCosts,
  defaultDescription,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
  useRentPriceTypeCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentStoreRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    mainFloorSpace: validationRules.mainFloorSpaceRequired,
    separableSpace: validationRules.separableSpace,
    totalFloorSpace: validationRules.totalFloorSpaceOptional,
    price: useRentPriceTypeCondition,
  },
  costs: { ...defaultCosts, courtageNote: validationRules.courtageNote, courtage: validationRules.courtage },
  otherFacilities: {
    frontWindowLength: validationRules.frontWindowLength,
    floorLoad: validationRules.floorLoad,
    totalFloorsNumber: validationRules.totalFloors,
    goodsLiftLoad: validationRules.loadLiftingValue,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  objectNumbers: defaultObjectNumbers,
  connections: defaultConnections,
  apiSearchData: defaultApiSearchData,
}
